import React from "react";
import styles from "./index.module.scss";
import Button from "../../UI/Button";
import Image from "next/image";

export default function TopArticle(props) {
  const { children, title, image, color, readingTime } = props;
  return (
    <div
      className={styles.container}
      style={{ backgroundColor: color || "inherit" }}
    >
      <div className={styles.row}>
        <div className={`${styles.col} ${styles.left} ${styles.isDesktop}`}>
          <div className={styles.image}>
            {image && (
              <Image
                src={image}
                loader={() => image}
                loading="lazy"
                width="355"
                height="220"
                alt={title}
              />
            )}
          </div>
        </div>
        <div className={`${styles.col} ${styles.right}`}>
          <div className={styles.content}>
            {readingTime && (
              <div className={styles.readingTime}>
                {readingTime} min to read
              </div>
            )}
            <h2 className={styles.title}>{title.trim()}</h2>
            <div
              className={`${styles.image} ${styles.mobile} ${styles.isMobile}`}
            >
              {image && <img src={image} alt={title} />}
            </div>
            <Button type="primary" title="Read" />
          </div>
        </div>
      </div>
    </div>
  );
}
